import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import LandingPage from './LandingPage';

const LandingPageRouter = (props) => {
  return (
    <Router>
      <LandingPage {...props} />
    </Router>
  );
};

export default LandingPageRouter;
